import ApiService from '../apiservice'

export default class ArquivoAtividadeService extends ApiService {

  constructor() {
    super('/arquivoAtividade')
  }

  incluirArquivoTemp(formData) {
    return this.post('/temp', formData);
  }

  listarArquivosTemp(usuario) {
    return this.get(`/listarArquivosTemp/${usuario}`);
  }

  excluirArquivosTemp(usuario) {
    return this.delete(`/excluirArquivosTemp/${usuario}`);
  }

  excluirArquivoTemp(codigo) {
    return this.delete(`/excluirArquivoTemp/${codigo}`);
  }

  consultarArquivoTemp(codigo) {
    return this.get(`/consultarArquivoTemp/${codigo}`);
  }

  adicionarDescricaoTemp(arquivo) {
    return this.put(`/adicionarDescricaoTemp/${arquivo.codigo}`, arquivo);
  }

  incluirArquivo(formData) {
    return this.post('/', formData);
  }

  listarArquivos(atividade) {
    return this.get(`/listarArquivos/${atividade}`);
  }

  consultarArquivo(codigo) {
    return this.get(`/consultarArquivo/${codigo}`);
  }

  adicionarDescricao(arquivo) {
    return this.put(`/adicionarDescricao/${arquivo.codigo}`,arquivo);
  }

  excluirArquivo(codigo) {
    return this.delete(`/excluirArquivo/${codigo}`);
  }

  downloadTemp(codigo) {
    return this.get2(`/downloadTemp/${codigo}`);
  }

  download(codigo,file) {
    return this.get2(`/download/${codigo}/${file}`);
  }

  exibirArquivo(file,codigo) {
    return this.get2(`/exibir/arquivo?filename=${file}&codigoAtividade=${codigo}`);
  }

  exibirArquivoTemp(file,usuarioId) {
    return this.get2(`/exibir-arquivo-temp/${file}/${usuarioId}`);
  }
}